import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted } from 'vue';
import NutritionLabelRepository from '@/utils/API/NutritionLabelRepository';
import { CautionaryFrontOfPackRenderData } from '@/models/NutritionLabels/ExportLabelState';
import { FOPLabelFormatData } from '@/models/NutritionLabels/FOPLabelFormatData';
import { LabelTypeMetadata } from '@/models/NutritionLabels/LabelTypeMetadata';
import { SupportedPDS } from '@/models/NutritionLabels/SupportedPDS';
import { useTranslations } from "@/hooks/useTranslations";
import { NutritionCountry } from "@/models/NutritionLabels/NutritionCountry";
import {LabelLanguage} from "@/models/NutritionLabels/LabelLanguage";


export default /*#__PURE__*/_defineComponent({
  __name: 'vCautionaryFOPConfig',
  props: {
    labelLanguage: null,
    nutritionCountry: null,
    value: null,
    recipeId: null
  },
  emits: ['update:value', 'label-loading', 'preview-update'],
  setup(__props: any, { emit }) {

const props = __props as {
  labelLanguage: LabelLanguage;
  nutritionCountry: NutritionCountry;
  value: CautionaryFrontOfPackRenderData;
  recipeId: number;
};




const localModel = ref<CautionaryFrontOfPackRenderData>(structuredClone(props.value));

watch(localModel, (newVal) => {
  emit('update:value', newVal);
}, { deep: true });

const labelFormatOptions = ref<FOPLabelFormatData[]>([]);
const pdsSizeOptions = ref<SupportedPDS[]>([]);
const selectedFormat = ref<FOPLabelFormatData>();
const selectedPDS = ref<SupportedPDS>();

let translations = ref(useTranslations());

onMounted(() => {
  loadLabelFormats();
});

function foPFormatReducer(fopData: FOPLabelFormatData) {
  return fopData.formatValue;
}

function foPPDSReducer(pdsData: SupportedPDS) {
  return pdsData.translationKey;
}

function translate(key: string) {
  return translations.value.get(key);
}

async function loadLabelFormats() {
  if (
    props.nutritionCountry &&
    props.nutritionCountry.name === "Canada"
  ) {
    try {
      const response = await NutritionLabelRepository.getCautionaryFrontOfPackageOptions(
        props.labelLanguage
      );
      labelFormatOptions.value = response.data;

      const savedFormat = labelFormatOptions.value.find(
        (x) => x.formatValue === localModel.value.fopFormat
      );

      updateFOPSelections(savedFormat || labelFormatOptions.value[0]);
    }
    catch (error) {
      console.error("Error loading label formats:", error);
    }
  }
}

function updateFOPSelections(selected: FOPLabelFormatData) {
  selectedPDS.value = selected.supportedPDS.find(
    (x) => x.value === localModel.value.pdsSize
  ) || null;

  selectedFormat.value = selected;
  pdsSizeOptions.value = selected.supportedPDS;

  fetchFOPLabel();
}

async function fetchFOPLabel() {
  try {
    emit('label-loading', true);

    const data = {
      recipeId: props.recipeId,
      labelFormatValue: localModel.value.fopFormat,
      pdsSizeValue: localModel.value.pdsSize,
      labelType: LabelTypeMetadata.CautionaryFrontOfPack,
      highInMetadata: 0,
    };
    const response = await NutritionLabelRepository.previewCautionaryFOPNutritionLabel(data);

    emit('preview-update', response.data.content);
  }

  catch (error) {
    console.error("Error fetching FOP label preview:", error);
  }

  finally {
    emit('label-loading', false);
  }
}

async function fetchLabelFormats(selected: FOPLabelFormatData) {
  selectedFormat.value = selected;
  localModel.value.fopFormat = selected.formatValue;
  await populatePDSSizes(selected.supportedPDS);
}

async function populatePDSSizes(supportedPDS: SupportedPDS[]) {
  pdsSizeOptions.value = supportedPDS;
  selectedPDS.value = pdsSizeOptions.value[0];

  localModel.value.pdsSize = selectedPDS.value.value;
  await fetchFOPLabel();
}

async function fetchPreview() {
  localModel.value.pdsSize = selectedPDS.value.value || null;
  await fetchFOPLabel();
}

return { __sfc: true,props, emit, localModel, labelFormatOptions, pdsSizeOptions, selectedFormat, selectedPDS, translations, foPFormatReducer, foPPDSReducer, translate, loadLabelFormats, updateFOPSelections, fetchFOPLabel, fetchLabelFormats, populatePDSSizes, fetchPreview }
}

})